import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';
import type { MemberEditTab } from '@core/tellent-types';

export type EditMemberDialogOpenContext = 'members_table_row' | 'members_table_dropdown' | 'client';

@Injectable({ providedIn: 'root' })
export class EditMemberAnalyticsService extends AnalyticsBase {
  public readonly namespace = 'EditMemberDialog';
  public readonly requireViewContext = false;

  public trackDialogOpen(context: EditMemberDialogOpenContext): void {
    this.track('DialogOpen', { opened_from: context });
  }

  public trackSelectedTab(tab: MemberEditTab): void {
    this.track('TabSelected', { tab });
  }
}
